<template>
    <div class="reset-div">
        <v-container>
            <v-row dense class="justify-center">
                <v-col cols="12">
                    <v-img
                    :src="require('../assets/logo-uys.png')"
                    class="my-3"
                    contain  
                    height="70" 
                    />
                </v-col>
                <v-col cols="10">
                    <h4>Création d'un nouveau mot de passe</h4>
                </v-col>
                <v-col cols="10"> 
                    <v-text-field 
                        v-model="password"
                        :type="'password'"
                        label="Nouveau mot de passe"
                        hide-details
                    ></v-text-field>
                </v-col>
                <v-col cols="10"> 
                    <v-text-field 
                        v-model="password2"
                        :type="'password'"
                        label="Confirmation du mot de passe"
                        hide-details
                    ></v-text-field>
                </v-col>
                 <v-col v-if="error != ''" cols="10" class="error-text"> 
                    {{this.error}}
                </v-col>
                <v-col cols="10" class="mt-4"> 
                    <v-btn depressed small color="primary" @click="changeMdp">Enregistrer</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'ResetPass',
    props: ['token'],
    data() {
        return {
            password: "",
            password2: "",
            error: ""
        }
    },
    methods: {
        changeMdp: function(){
            if(this.password == this.password2){
                this.$store.dispatch('setLoader', true).then((e) => {
                    var payload = {
                        email: this.$store.state.resetPass.email,
                        token: this.token,
                        new_password: this.password
                    }
                    this.$store.dispatch("changePassword", payload).then((e) => {
                        var payloadLogin = {
                            email: this.$store.state.resetPass.email,
                            password: this.password
                        }
                        this.$store.dispatch("getAuth", payloadLogin).then((e) => {
                            this.$store.dispatch('getProjets', {}).then((e) => {
                                this.$router.push({name: "Operations"})
                            })
                        })
                    })
                    
                }) 
            } else {
                this.error = "Les mots de passe ne correspondent pas."
            }
        }
    },
    created() {
        this.$store.dispatch('setLoader', true).then((e) => {
            this.$store.dispatch("checkTokenAuthent", {token: this.token}).then((e) => {
                if(!this.$store.state.resetPass){
                    this.$router.push({ name: 'Login' })
                }
                if(this.$store.state.loader){
                    this.$store.dispatch('setLoader', false)
                }
            })
        })        
    },
}
</script>
<style lang="scss">
    .reset-div {
        //background-color: #eb566b;
        height:100vh;
        display:flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align:center;
        .v-image {
            height:20vh
        }
        .error-text {
            color:red;
        }
    }
</style>